<!-- 
ConfirmFamilyModal.vue
功能：確認加入家戶類型視窗
作者：i9400538 陳博承
完成：2021-07-28
-->
<template>
  <div id="confirm-family-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 pl-0">
            <h3 class="modal-title">請選擇歸戶方式</h3>
          </div>
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="padding-20-40">
          <div class="row">
            <div class="div-margin-block">
              <button
                class="btn btn-primary mr-0"
                type="button"
                @click="$emit('addToCurrentFamily')"
              >加入現有家戶</button>
              <button
                class="btn btn-primary mr-0"
                type="button"
                @click="$emit('createNewFamily')"
              >建立新的家戶</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmFamilyModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      dafault: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.padding-20-40 {
  padding: 20px 40px;
}
.div-margin-block {
  margin-left: auto;
  margin-right: 0;
}
</style>